import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'
//
export const countryListApi = () => API.get(URL.COUNTRY_LIST_URL)
